import JobDetailsContainer from "../../Componant/JobSearch/jobDetails";

const JobDetails = () => {
  return (
    <div className="page-body">
      <JobDetailsContainer />
    </div>
  );
};

export default JobDetails;
